module.exports = __webpack_public_path__ + "img/shopping-cart.2d63e80d.svg";